import React, { useEffect, useState } from "react";
import {  MDBContainer, MDBFooter } from "mdbreact";
import "./App.css";
import {
  MenuItem,
  FormControl,
  Select,
  CardContent,
  Card,
} from "@material-ui/core";
import InfoBox from "./InfoBox";
import Map from "./Map";
import Table from "./Table";
import { sortData, prettyPrintStat, prettyPrintTotal } from "./util";
import LineGraph from "./LineGraph";
import "leaflet/dist/leaflet.css";
import "./InfoBox.css";

function App() {
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("worldwide");
  const [countryInfo, setCountryInfo] = useState({});
  const [tableData, setTableData] = useState([]);
  const [mapCenter, setMapCenter] = useState([39,34]);
  const [zoom, setZoom] = useState(2);
  const [mapCountries, setMapCountries] = useState([]);
  const [casesType, setCasesType] = useState("cases");
  const [isLoading, setLoading] = useState(false);


  useEffect(() => {
    fetch("https://disease.sh/v3/covid-19/all")
      .then((response) => response.json())
      .then((data) => {
        setCountryInfo(data);
      });
  }, []);

  useEffect(() => {
    const getCountriesData = async () => {
      await fetch("https://disease.sh/v3/covid-19/countries")
        .then((response) => response.json())
        .then((data) => {
          const countries = data.map((country) => ({
            name: country.country,
            value: country.countryInfo.iso2,
          }));

          const sortedData = sortData(data);
          setTableData(sortedData);
          setMapCountries(data);
          setCountries(countries);
        });
    };

    getCountriesData();
  }, []);

  const onCountryChange = async (event) => {
    setLoading(true);
    const countryCode = event.target.value;

    setCountry(countryCode);

    const url =
      countryCode === "worldwide"
        ? "https://disease.sh/v3/covid-19/all"
        : `https://disease.sh/v3/covid-19/countries/${countryCode}`;

    //https://disease.sh/v3/covid-19/all
    //https://disease.sh/v3/covid-19/countries/[countryCode]

    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setCountry(countryCode);
        setCountryInfo(data);
        setLoading(false);
        // console.log([data.countryInfo.lat, data.countryInfo.long]);
        countryCode === "worldwide"
          ? setMapCenter([39,34])
          : setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
        countryCode === "worldwide"
        ? setZoom(2): setZoom(4);
      });

    
  };
  console.log(countries);
  function search(nameKey, myArray){
    for (var i=0; i < myArray.length; i++) {
        if (myArray[i].value === nameKey) {
            return myArray[i].name;
        }
    }
    return "Worldwide";
}
  return (
    <div>
      <div className="app">
        <div className="app__left">
          <div className="app__header">
            <h1>Covid-19 Tracker</h1>
            <FormControl className="app__dropdown">
              <Select
                variant="outlined"
                onChange={onCountryChange}
                value={country}
              >
                <MenuItem value="worldwide">Worldwide</MenuItem>
                {countries.map((country) => (
                  <MenuItem value={country.value}>{country.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="app__stats">
            <InfoBox
              isRed
              active={casesType === "cases"}
              className="infoBox__cases"
              onClick={(e) => setCasesType("cases")}
              title="Coronavirus Cases"
              total={prettyPrintTotal(countryInfo.cases)}
              cases={prettyPrintStat(countryInfo.todayCases)}
              isloading={isLoading}
            />
            <InfoBox
              active={casesType === "recovered"}
              className="infoBox__recovered"
              onClick={(e) => setCasesType("recovered")}
              title="Recovered"
              total={prettyPrintTotal(countryInfo.recovered)}
              cases={prettyPrintStat(countryInfo.todayRecovered)}
              isloading={isLoading}
            />
            <InfoBox
              isGrey
              active={casesType === "deaths"}
              className="infoBox__deaths"
              onClick={(e) => setCasesType("deaths")}
              title="Deaths"
              total={prettyPrintTotal(countryInfo.deaths)}
              cases={prettyPrintStat(countryInfo.todayDeaths)}
              isloading={isLoading}
            />
          </div>
          
          <Map
            countries={mapCountries}
            center={mapCenter}
            zoom={zoom}
            casesType={casesType}
          />
        </div>
        <Card className="app__right">
          <CardContent>
            <h3>Live Cases by Country</h3>
            <Table countries={tableData} />
            <h3 className="app__graphTitle">
              {search(country,countries)} New {casesType}</h3>
            <LineGraph className="app__graph" casesType={casesType} countryCode = {country} />
          </CardContent>
          
        </Card>
      </div>
      <div className="footer-copyright text-center py-3">
    <MDBFooter color="#ff4d4d">
    <MDBContainer fluid>
             &copy; Atharva Ghodmare 
    </MDBContainer>

    </MDBFooter>
    
  </div>
    
  </div>
  );
}

export default App;